/* eslint-disable no-param-reassign */

import { useCallback } from 'react';

export const useNumericStepperCalculation = ({
    incrementBy,
    minValue,
    maxValue,
}: {
    incrementBy: number;
    maxValue?: number;
    minValue?: number;
}) => {
    const isMaxValue = useCallback(
        (value: number) => (maxValue !== undefined ? value >= maxValue : false),
        [maxValue],
    );
    const isMinValue = useCallback(
        (value: number) => (minValue !== undefined ? value <= minValue : false),
        [minValue],
    );

    const minMaxGuard = useCallback(
        (value: number) => {
            if (maxValue !== undefined && isMaxValue(value)) {
                return maxValue;
            }

            if (minValue !== undefined && isMinValue(value)) {
                return minValue;
            }

            return value;
        },
        [isMaxValue, isMinValue, maxValue, minValue],
    );

    const calculateSubstractValue = useCallback(
        (oldQuantity: number) => {
            const newQuantity = oldQuantity - incrementBy;
            return minMaxGuard(newQuantity);
        },
        [incrementBy, minMaxGuard],
    );

    const calculateAdditionValue = useCallback(
        (oldQuantity: number) => {
            const newQuantity = oldQuantity + incrementBy;
            return minMaxGuard(newQuantity);
        },
        [incrementBy, minMaxGuard],
    );

    return {
        isMaxValue,
        isMinValue,
        calculateAdditionValue,
        calculateSubstractValue,
        minMaxGuard,
    };
};
